import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '../../core/api';
import { List, ResponseDatas } from '../../core/api/types';

import { CreateNoteRequest, GetNotesParams, Note } from './types';

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  constructor(private readonly apiService: ApiService) {}

  addNote(note: CreateNoteRequest): Observable<Note> {
    return this.apiService.post<Note>('notes', note);
  }

  deleteNote(id: number): Observable<void> {
    return this.apiService.delete(`notes/${id}`);
  }

  getNotes(params: GetNotesParams): Observable<List<Note>> {
    return this.apiService
      .get<ResponseDatas<List<Note>>>('notes', { params: new HttpParams({ fromObject: params }) })
      .pipe(map((result) => result?.datas));
  }
}
